module.exports = __webpack_public_path__ + "img/hotel_thumbnail.e3f7fb24.jpeg";